import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";

import CloseIcon from "../Common/CloseIcon";
import { I18n } from "@aws-amplify/core";
import Button from '@material-ui/core/Button';

import images from "../../assets/img/images";


const styles = {
    container: {
        width: 367,
        height: 250
    },
    close: {
        float: "right",
        margin: 10,
        display: "inline",
    },
    warning: {
        right: -180,
        top: 80,
        color: "red"
    },
    warningMessage: {
        top: 100,
        left: 35,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    buttons: {
        display: "table",
        margin: "0 auto",
        left: 30,
        top: 152
    }
};

const ZoneError = withStyles(styles)((props) => {
    const {
        classes,
        handleClose,
    } = props;

    return (
        <div className={classes.container}>
            <div className={classes.close}>
                <CloseIcon closeFunction={handleClose} />
            </div>
            <div style={{ height: 0 }}>
                <img src={images.deleteWarning} className={classes.warning} alt="warning"></img><br />
                <span className={classes.warningMessage}>{I18n.get("zone_error")}</span>
            </div>
            <div className={classes.buttons}>
                <Button onClick={() => { handleClose() }} style={{ top: "-4px", left: "14px"}} variant="contained" color="primary">
                    {I18n.get("profiles_pass")}
                </Button>
            </div>


        </div>
    );

});

export default withRouter(ZoneError);
